export class Tag {
  name: string
  slug: string

  toJSON() {
    return { ...this }
  }
}
